function DateTimeUtilitiesService(bbTimeZone) {
    'ngInject';

    /***
     * @ngdoc method
     * @name checkPerson
     * @methodOf BB:DateTimeUtilities
     * @description
     * Checks if basket_item has default person
     * @param {Object} basket_item The basket item object
     * @param {Object} item_defaults The item defaults object
     *
     * @returns {boolean} Whether the basket item has a default person.
     */
    const checkPerson = (basket_item, item_defaults) => {
        return (basket_item.defaults.person && (basket_item.defaults.person.self === basket_item.person.self)) || _.isBoolean(basket_item.person) || item_defaults.merge_people;
    };

    /***
     * @ngdoc method
     * @name checkResource
     * @methodOf BB:DateTimeUtilities
     * @description
     * Checks if basket_item has default resource
     * @param {Object} basket_item The basket item object
     * @param {Object} item_defaults The item defaults object
     *
     * @returns {boolean} Whether the basket item has a default resource.
     */
    const checkResource = (basket_item, item_defaults) => {
        return (basket_item.defaults.resource && (basket_item.defaults.resource.self === basket_item.resource.self)) || _.isBoolean(basket_item.resource) || item_defaults.merge_resources;
    };


    return {
        setTimeToMoment,
        convertTimeToMoment,
        convertMomentToTime,
        checkDefaultTime
    };


    function setTimeToMoment(date, time) {
        // If time is 24:00, add 1 day to date
        let _date = angular.copy(date);
        if (time === '24:00') {
            _date = _date.add(1, 'days');
        }

        const newDate = moment(time, 'HH:mm');
        newDate.set({
            year: parseInt(_date.get('year')),
            month: parseInt(_date.get('month')),
            date: parseInt(_date.get('date')),
            second: 0
        });
        return newDate;
    }


    /***
     * @ngdoc method
     * @name convertTimeToMoment
     * @methodOf BB:DateTimeUtilities
     * @description
     * Converts date and time to valid moment object
     * @param {Moment} date The date object to convert
     * @param {integer} time The time integer to convert
     *
     * @returns {object} Moment object converted from date/time
     */
    function convertTimeToMoment(date, time) {
        if (!date || !moment.isMoment(date) || !angular.isNumber(time)) {
            return;
        }

        let datetime = moment(date);
        datetime = bbTimeZone.convertToCompany(datetime);

        const val = parseInt(time);
        const hours = parseInt(val / 60);
        const mins = val % 60;
        datetime.hour(hours);
        datetime.minutes(mins);
        datetime.seconds(0);

        datetime.year(date.year());
        datetime.month(date.month());
        datetime.date(date.date());

        return datetime;
    }


    /***
     * @ngdoc method
     * @name convertMomentToTime
     * @methodOf BB:DateTimeUtilities
     * @description
     * Converts moment object to time
     * @param {Moment} datetime the datetime object to convert
     *
     * @returns {integer} Datetime integer converted from moment object
     */
    function convertMomentToTime(datetime) {
        return datetime.minutes() + (datetime.hours() * 60);
    }

    /***
     * @ngdoc method
     * @name checkDefaultTime
     * @methodOf BB:DateTimeUtilities
     * @description
     *  Checks if basket_item default time exists
     * @param {Moment} date The date object
     * @param {Array} time_slots An array of time slots
     * @param {Object} basket_item The basket item object
     * @param {Object} item_defaults The item defaults object
     * @returns {Object} object describing matching slot
     */
    function checkDefaultTime(date, time_slots, basket_item, item_defaults) {
        let match, slot;
        if (!basket_item.defaults.time) {
            match = null;
        } else if (checkPerson(basket_item, item_defaults) && checkResource(basket_item, item_defaults)) {
            match = 'full';
        } else {
            match = 'partial';
        }

        let found_time_slot = null;

        if (basket_item.defaults.time && ((basket_item.defaults.date && date.isSame(basket_item.defaults.date, 'day')) || !basket_item.defaults.date)) {

            const time = basket_item.time ? basket_item.time.time : basket_item.defaults.time;

            for (slot of Array.from(time_slots)) {
                if (time && (time === slot.time) && (slot.avail === 1)) {
                    found_time_slot = slot;
                    break;
                }
            }
        }

        return {
            match,
            slot: found_time_slot
        };
    }

}

/***
 * @ngdoc service
 * @name BB:DateTimeUtilities
 *
 * @description
 * Service for manipulating datetime objects
 *
 */
angular
    .module('BB')
    .service('DateTimeUtilitiesService', DateTimeUtilitiesService);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/datetime_utilities.service.js